import { BaseUrl, get, post } from "./api";

export const getMyUser = async () => {
    return await get(`api/MyUser`, null,
        BaseUrl.Centerpoint);
}
export const updateUserProfile = async (request) => {
    return await post(`api/MyUser`, request, null,
        BaseUrl.Centerpoint);
}